import { useState, useEffect, useCallback } from 'react';
import Config from '../utils/config';

export function useConfig<T = any>(key: string): T | undefined {
  const [value, setValue] = useState<T | undefined>(() => Config.get(key));

  useEffect(() => {
    const unsubscribe = Config.subscribe((changedKey: string) => {
      if (changedKey === '*' || changedKey === key || key.startsWith(changedKey + '.')) {
        setValue(Config.get(key));
      }
    });
    return unsubscribe;
  }, [key]);

  return value;
}

export function useConfigAll(): Record<string, any> {
  const [config, setConfig] = useState<Record<string, any>>(() => Config.getAll());

  useEffect(() => {
    const unsubscribe = Config.subscribe(() => {
      setConfig(Config.getAll());
    });
    return unsubscribe;
  }, []);

  return config;
}

export function useConfigState<T = any>(key: string): [T | undefined, (newValue: any) => void] {
  const value = useConfig<T>(key);
  const setter = useCallback((newValue: any) => Config.set(key, newValue), [key]);
  return [value, setter];
}

export default useConfig;
